import { combineReducers } from "redux";
import aboutUsReducer from "./aboutUs";
import brokerReducer from "./broker";
import brokerageReducer from "./brokerage";
import brokeragesReducer from "./brokerages";
import componentsReducer from "./components";
import quotesReducer from "./quotes";
import compareviewReducer from "./compareview";
import operationsReducer from "./operations";
import productReducer from "./products";
import reditReducer from "./redit";
import qfReducer from "./qf";
import userManagement from "./userManagement";
import groupManagement from "./groupManagement";
import categoryManagement from "./categoryManagement";
import logoandcolor from "./logoandcolor";
import verticals from "./verticals";
import insurers from "./insurers";
import myquotesReducer from "./myquotes";
import mycustomersReducer from "./mycustomers";
import mybinderReducer from "./mybinder";
import myReminderReducer from "./myreminder";
import transactionsReducer from "./transactions";
import policyStatus from "./policyStatus";
import passwordManagement from "./passwordManagement";
import stripeTransactionReducer from "./stripeTransaction";
import certificateReducer from "./certificate";
import paymentProviderReducer from "./paymentprovider";
import brokeragePaymentProviderReducer from "./brokeragePaymentProvider";
import brokerageIpfsDetailsReducer from "./brokerageIpfsDetails";
import insurerCodeReducer from "./insurercode";
import mgaCodeReducer from "./mgacode";
export default combineReducers({
  aboutUs: aboutUsReducer,
  broker: brokerReducer,
  brokerage: brokerageReducer,
  brokerages: brokeragesReducer,
  components: componentsReducer,
  quotes: quotesReducer,
  operations: operationsReducer,
  products: productReducer,
  redit: reditReducer,
  qf: qfReducer,
  userManagement: userManagement,
  groupManagement: groupManagement,
  categoryManagement: categoryManagement,
  logoandcolor: logoandcolor,
  myquotes: myquotesReducer,
  mycustomers: mycustomersReducer,
  mybinder: mybinderReducer,
  myreminder: myReminderReducer,
  stripeTransaction: stripeTransactionReducer,
  certificate: certificateReducer,
  transactions: transactionsReducer,
  compareview: compareviewReducer,
  verticals: verticals,
  insurers: insurers,
  policyStatus: policyStatus,
  passwordManagement: passwordManagement,
  paymentManagement: paymentProviderReducer,
  brokerageProvider: brokeragePaymentProviderReducer,
  brockerageIpfsDetails: brokerageIpfsDetailsReducer,
  insurerCode: insurerCodeReducer,
  mgaCode: mgaCodeReducer,
});
